<div class="video-overlay"></div>
<video playsinline autoplay muted loop>
  <source src="assets/img/confetti.mp4" type="video/mp4">
</video>

<div class="flex-center">
  <div class="text-center">
    <h2>{{ 'SOHAPPY.TITLE' | translate }}</h2>
    <h3 class="my-5">{{ 'SOHAPPY.TEXT' | translate }}</h3>
    <a routerLink="info" class="animated pulse infinite btn btn-rounded blue-gradient">
      {{ 'SOHAPPY.BUTTON' | translate }}</a>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/components/so-happy/so-happy.component.html